import React from 'react';
import { Dialog, T } from '@colonist/ui';
import { ShareImagePreview } from './ShareImagePreview/ShareImagePreview.tsx';
import { ShareImageSwitcher } from './ShareImageSwitcher/ShareImageSwitcher.tsx';
import { ShareImageDialogFooter } from './ShareImageDialogFooter/ShareImageDialogFooter.tsx';
import styles from './ShareImageDialog.module.scss';
/* Dialog for sharing end-game result images */ export const ShareImageDialog = ({ open, onClose, image, imageOptions, selectedImageId, onSelectImage, footer, onFooterAction })=>{
    const isLoading = image.status == 'loading';
    return /*#__PURE__*/ React.createElement(Dialog, {
        open: open,
        onClose: onClose
    }, /*#__PURE__*/ React.createElement(Dialog.Title, null, /*#__PURE__*/ React.createElement(T, {
        id: {
            key: 'strings:game.endGame.shareImagePopup.title'
        }
    })), /*#__PURE__*/ React.createElement(Dialog.Content, null, /*#__PURE__*/ React.createElement("div", {
        className: styles.content
    }, /*#__PURE__*/ React.createElement(ShareImageSwitcher, {
        options: imageOptions,
        selectedImageId: selectedImageId,
        onSelectImage: onSelectImage
    }), /*#__PURE__*/ React.createElement(ShareImagePreview, image))), !isLoading && /*#__PURE__*/ React.createElement(ShareImageDialogFooter, {
        footer: footer,
        onFooterAction: onFooterAction
    }));
};
